import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import './Icon.css';
const iconPrefix = 'data:image/svg+xml;utf8,';
const Icon = ({ icon, size = 'medium', className = '' }) => {
    const divRef = React.useRef(null);
    useEffect(() => {
        const div = divRef.current;
        if (div)
            div.innerHTML = icon.startsWith(iconPrefix) ? icon.substring(iconPrefix.length) : `<svg><use xlink:href="${icon}"></use></svg>`;
    }, [icon, divRef]);
    return (_jsx("div", { className: `icon ${size} ${className !== null && className !== void 0 ? className : ''}`, ref: divRef }));
};
export default Icon;
